<template>
  <div class="page-wrapper highlightlist-page highlight-page newsdetail-page">
    <div class="container">
      <a-row :gutter="[32, 32]">
        <a-col :lg="16">
          <div class="news-detail highlight-detail">
            <BaseLoading  opaque :spinning="collegeTeamHighlightLoading" size="large">
              <div class="news-image highlight-image">
                <img
                  :src="generateImageUrl(collegeTeamHighlight.image)"
                  alt="Highlight image"
                />
              </div>
              <div class="news-text-detail highlight-text-detail">
                <div class="extra-info">
                  <div class="date-info">
                    <a-icon type="clock-circle" />{{
                      collegeTeamHighlight.createdAt | humanizeDate
                    }}
                  </div>
                </div>
                <div class="news-title highlight-title">
                  {{ collegeTeamHighlight.title }}
                </div>
                <div class="news-description highlight-description">
                  <p class="w-space-preline">{{ collegeTeamHighlight.description }}</p>
                </div>
                <div class="extra-info tags">
                  <span>Related Videos:</span>
                </div>
                <div class="highlight-videos-content">
                  <a-row :gutter="[32, 32]">
                    <a-col :md="12">
                      <div class="highlight-videos-wrapper">
                        <figure class="thumbnail">
                          <video-embed
                            :src="collegeTeamHighlight.video1"
                            sandbox="allow-scripts allow-same-origin allow-presentation"
                          ></video-embed>
                          <a>
                            <figcaption>
                              {{ collegeTeamHighlight.videoDesc1 }}
                            </figcaption>
                          </a>
                        </figure>
                      </div>
                    </a-col>
                    <a-col :md="12">
                      <div class="highlight-videos-wrapper">
                        <figure class="thumbnail">
                          {{ collegeTeamHighlight.videoUrl2 }}
                          <video-embed
                            :src="collegeTeamHighlight.video2"
                            sandbox="allow-scripts allow-same-origin allow-presentation"
                          ></video-embed>
                          <a>
                            <figcaption>
                              {{ collegeTeamHighlight.videoDesc2 }}
                            </figcaption>
                          </a>
                        </figure>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </BaseLoading>
          </div>
        </a-col>
        <a-col :lg="8">
          <div class="news-side-bar-wrap">
            <div class="side-content">
              <div class="box-wrapper recent-news">
                <div class="head-title">Recent Highlights</div>
                <ul class="list news-list">
                  <li
                    class="news-card"
                    v-for="(highlight, index) in recentHighlights"
                    :key="index"
                    @click="handleImageClick(highlight.id)"
                  >
                    <div class="img-wrap">
                      <img
                        :src="generateImageUrl(highlight.image)"
                        alt="New Title"
                        v-if="highlight.image"
                      />
                    </div>
                    <div class="text-detail">
                      <div class="title">{{ highlight.title }}</div>
                      <div class="extra-info">
                        <div class="date-info">
                          <a-icon type="clock-circle" />
                          {{ highlight.createdAt | humanizeDate }}
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="button-wrap">
                  <BaseButton
                    class="button"
                    type="primary"
                    @click="handleViewAllHighlights"
                  >
                    <div class="view-all">View All Highlights</div>
                  </BaseButton>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { CollegeTeamHighlight } from "@/models";
import { mapGetters } from "vuex";
import CollegeForm from "./form";

const COLLEGE_TEAM_HIGHLIGHT_STORE = "collegeTeamHighlightStore";

export default {
  components: {
    CollegeForm
  },
  created() {
    this.dispatcher(this.$route.params.id);
  },
  data() {
    return {
      resource: new CollegeTeamHighlight()
    };
  },
  computed: {
    collegeId() {
      return this.$route.params["collegeId"] || localStorage["college-id"];
    },
    profileId() {
      return CollegeTeamHighlight.profileId();
    },
    ...mapGetters({
      collegeTeamHighlight: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlight`,
      collegeTeamHighlights: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlights`,
      collegeTeamHighlightLoading: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlightLoading`
    }),
    recentHighlights() {
      return this.collegeTeamHighlights
        .filter(item => item.id !== this.collegeTeamHighlight.id)
        .slice(0, 6);
    }
  },
  methods: {
    handleImageClick(id) {
      this.$router.push(
        `/${this.profileId}/college_profile/team_highlights/${id}/show/${this.collegeId}`
      );
    },
    async dispatcher(id) {
      await this.$store.dispatch(
        `${COLLEGE_TEAM_HIGHLIGHT_STORE}/getCollegeTeamHighlight`,
        {
          id
        }
      );
      await this.$store.dispatch(
        `${COLLEGE_TEAM_HIGHLIGHT_STORE}/getCollegeTeamHighlights`,
        {
          id: this.collegeId,
          limit: 7,
          sort: "-createdAt"
        }
      );
    },
    handleViewAllHighlights() {
      this.$router.push(
        `/${this.profileId}/college_profile/${this.collegeTeamHighlight.collegeId.id}/team_highlights`
      );
    }
  }
};
</script>

<style lang="sass" scoped>
.button-wrap
  display: flex
  justify-content: center
  border-top: 1px solid #ccc
  .button
    margin-top: 1rem
    width: 100%
</style>
